import React, { useState } from "react";
import { NavLink } from "react-router";
import logo1 from "../../data/logo.PNG"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-black p-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="text-red-500 text-2xl font-bold">
          <img src={logo1} alt="" className="w-[50px] h-[50px]"/>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6 text-white ">
          <li className=""><NavLink to={"/"} className="hover:text-red-500 ">Home</NavLink></li>
          <li><NavLink to={"/AboutUs"} className="hover:text-red-500">About Us</NavLink></li>
          <li><NavLink to={"/Products"} className="hover:text-red-500">Products</NavLink></li>
          <li><NavLink to={"/ContectUs"} className="hover:text-red-500">ConteatUs</NavLink></li>
        </ul>

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden text-white text-xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <ul className="md:hidden flex flex-col space-y-4 text-white mt-2">
           <li><NavLink to={"/"} className="hover:text-red-500">Home</NavLink></li>
          <li><NavLink to={"/AboutUs"} className="hover:text-red-500">About Us</NavLink></li>
          <li><NavLink to={"/Products"} className="hover:text-red-500">Products</NavLink></li>
          <li><NavLink to={"/ContectUs"} className="hover:text-red-500">ContectUs</NavLink></li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;